<template>
  <div class="card">
    <div class="card__media">
      <AtomImage class="object-cover" :src="post.image?.src?.medium" :alt="post.image?.alt || post?.title" />
    </div>
    <div class="card__info">
      <p class="card__label" v-if="post.categories?.length">{{ $t(`shared.category.${post.categories[0]?.slug}`) }}</p>
      <h2 class="card__heading">{{ post.title }}</h2>
      <p class="card__leading">{{ post.excerpt }}</p>
      <div class="card__button">
        <button class="button-coral-outline !text-white">Läs mer</button>
      </div>
      <!-- <div class="card__meta">
        <AtomIcon name="calendar" class="-mt-px" />
        {{ $t('shared.updatedAt', { date: toDayjs(post.modifiedDate).fromNow() }) }}
      </div> -->
    </div>
  </div>
</template>

<script setup>
const props = defineProps({
  post: {
    type: Object,
    default: () => {}
  }
})
</script>

<style lang="scss" scoped>
.card {
  @apply @container;
  @apply rounded overflow-hidden relative;

  &__media {
    @apply relative bg-black w-full;
    @apply aspect-square @md:aspect-3/2 @2xl:aspect-video;
  }

  &__info {
    @apply grid gap-2 text-white text-center;
    @apply absolute bottom-0 left-0 w-full py-8 px-3 @md:px-8 @md:pb-12;
    @apply bg-gradient-to-t from-25% from-black/80;
  }

  &__label {
    @apply font-bold uppercase tracking-[0.125em];
  }

  &__heading {
    @apply font-medium font-heading;
    @apply text-2xl max-w-[28ch] mx-auto;

    // 2up 
    @apply @md:text-4xl;

    // // 1up
    // @apply @2xl:text-6xl;
  }

  &__leading {
    @apply max-w-prose mx-auto;
    @apply max-md:text-sm;
  }

  &__button {
    @apply hidden;
    @apply mt-4 mx-auto text-xs;
  }

  &__meta {
    @apply mt-4 text-xs text-[#888] flex gap-2 items-center justify-center;
  }
}
</style>